<template>
  <div class="main">
    <slot></slot>
    <div class="main_header" v-if="showHeader">
      <slot name="header"></slot>
    </div>
    <div class="main_center">
      <slot name="center"></slot>
    </div>
    <div class="main_footer" v-if="showFooter">
      <slot name="footer"></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'layoutContainerMain',
  props: {
    showHeader: {
      type: Boolean,
      default: false
    },
    showFooter: {
      type: Boolean,
      default: false
    }
  }
}
</script>
<style lang="scss" scoped>
  .main {
    flex: 1;
    display: flex;
    flex-direction: column;
    background-color: #ffffff;
    padding: 20px;
    overflow: auto;
    &_header {
      display: flex;
      align-items: center;
      min-height: 50px;
      border-bottom: 1px solid $border-color-base;
    }
    &_center {
      flex: 1;
    }
    &_footer {
      display: flex;
      justify-content: center;
      align-items: center;
      min-height: 50px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/container/main/index.vue